import { hotTopics, heatDistribution } from "@/mocks/home";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-accent-600",
  down: "ri-arrow-down-line text-secondary-600",
  flat: "ri-subtract-line text-foreground-400",
};

export default function Ranking() {
  return (
    <section id="ranking" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-medium tracking-widest text-primary-600">TOPIC RANKING</p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              今日热度榜
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              按过去 24 小时的公开讨论量排序，只做信息归拢，不代表任何结论。
            </p>
          </div>
          <a
            href="#roundup"
            className="inline-flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer self-start md:self-auto"
          >
            完整榜单
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <ol className="lg:col-span-7 divide-y divide-background-200 border-y border-background-200">
            {hotTopics.map((item) => (
              <li key={item.rank}>
                <a
                  href="#roundup"
                  className="group flex items-center gap-4 px-1 py-3.5 transition-colors hover:bg-background-100 cursor-pointer"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      item.rank <= 3
                        ? "bg-accent-100 text-accent-700"
                        : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm md:text-[15px] text-foreground-900 group-hover:text-primary-700">
                      {item.title}
                    </span>
                  </span>
                  <span className="hidden sm:inline-flex shrink-0 items-center rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                    {item.tag}
                  </span>
                  <span className="flex w-14 shrink-0 items-center justify-end gap-0.5 text-xs text-foreground-600">
                    <i className={trendIcon[item.trend]} />
                    {item.heat}
                  </span>
                </a>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-5 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="font-heading text-base font-bold text-foreground-950">话题热度分布</h3>
            <p className="mt-1 text-xs text-foreground-600">按主题大类统计的讨论占比（示意）</p>
            <ul className="mt-6 space-y-5">
              {heatDistribution.map((item, idx) => (
                <li key={item.label}>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-foreground-800">{item.label}</span>
                    <span className="font-medium text-foreground-600">{item.value}%</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-300">
                    <div
                      className="h-full rounded-full bg-primary-500 animate-grow-bar"
                      style={{ width: `${item.value}%`, animationDelay: `${idx * 90}ms` }}
                    />
                  </div>
                </li>
              ))}
            </ul>
            <p className="mt-6 flex items-start gap-2 rounded-md border border-background-200 bg-background-50 p-3 text-xs leading-relaxed text-foreground-600">
              <i className="ri-information-line mt-0.5 text-sm text-secondary-600" />
              榜单与分布均由公开信息整理，仅供浏览参考。
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}